import axios from 'axios'

const csrfTokenDom = document.querySelector('[name=csrf-token]')

if (csrfTokenDom) {
  const csrfToken = csrfTokenDom.content
  axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken
}
